import React from 'react';
import PropTypes from 'prop-types';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Hidden } from '@mui/material';
import { MoreVert, ViewList, Menu } from '@mui/icons-material';
import { IconButton } from '@totalsoft/rocket-ui';
import { reduce } from 'ramda';
import menuConfig from 'constants/menuConfig';
import { useHeader } from 'providers/AreasProvider';
import { AppBar, Toolbar, MinimizeSidebar, HeaderResponsive, HeaderContentWrapper } from './HeaderStyle';
import { useTitle } from 'utils/hooks/useTitle';
import HeaderLinks from './HeaderLinks';
import HeaderDropdown from './HeaderDropdown';
import { useCallback } from 'react';
import { areas } from 'constants/areas';
import { withAreaSetter } from 'providers/AreasConsumers';

const flatten = (arr, value) => arr.concat(value).concat(value.children ? flattenConfig(value.children) : []);
const flattenConfig = config => reduce(flatten, [], config);

function Header({ setElemByAreaKey, drawerMinimized, handleDrawerMinimizeToggle, handleDrawerOpenToggle }) {
  const { t } = useTranslation();
  const location = useLocation();
  const [header] = useHeader();

  const headerRef = useCallback(
    elem => {
      setElemByAreaKey(areas.header, elem);
    },
    [setElemByAreaKey]
  );

  const makeBrand = pathname => {
    var name;
    flattenConfig(menuConfig).map(menu => {
      if (menu.path === pathname) {
        name = menu.name;
      }
      return null;
    });
    if (pathname === '/myProfile') {
      name = 'User';
    }

    return name || '';
  };

  const getPageTitle = () => {
    return pathName && t('NavBar.' + pathName);
  };

  const pathName = makeBrand(location.pathname);

  useTitle(getPageTitle());

  return (
    <AppBar position='sticky'>
      <Toolbar>
        <Hidden mdDown>
          <MinimizeSidebar>
            {drawerMinimized ? (
              <IconButton onClick={handleDrawerMinimizeToggle} color='primary' variant='text' size='medium'>
                <MoreVert fontSize='small' />
              </IconButton>
            ) : (
              <IconButton onClick={handleDrawerMinimizeToggle} color='primary' variant='text' size='medium'>
                <ViewList fontSize='small' />
              </IconButton>
            )}
          </MinimizeSidebar>
        </Hidden>

        {header}

        <HeaderContentWrapper ref={headerRef}></HeaderContentWrapper>

        <HeaderDropdown />

        <HeaderLinks />

        <Hidden mdUp>
          <HeaderResponsive>
            <IconButton color='primary' variant='text' size='medium' aria-label='open drawer' onClick={handleDrawerOpenToggle}>
              <Menu fontSize='small' />
            </IconButton>
          </HeaderResponsive>
        </Hidden>
      </Toolbar>
    </AppBar>
  );
}

Header.propTypes = {
  setElemByAreaKey: PropTypes.func.isRequired,
  drawerMinimized: PropTypes.bool.isRequired,
  handleDrawerMinimizeToggle: PropTypes.func,
  handleDrawerOpenToggle: PropTypes.func
};

export default withAreaSetter(Header);
